import { render } from "./BeneficiaryBadgeWizard.vue?vue&type=template&id=45928f40"
import script from "./BeneficiaryBadgeWizard.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadgeWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__